import { createSlice } from '@reduxjs/toolkit';
import { FormattedMessage } from 'react-intl';
import { fetchWrapper } from '../../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../../_helpers/_methods';
import { setUiError, setUiMessage } from './ui';

export const initialState = {
  loading: false,
  hasErrors: false,
  fiscalyear: [],
  totalCount: 0,
  activeFiscalYear: null
};

// A slice
const fiscalSlice = createSlice({
  name: 'fiscalyear',
  initialState,
  reducers: {
    setFiscalYear: (state, action) => {
      state.fiscalyear = action.payload.data;
      state.totalCount = action.payload.count;
    },
    setActiveFiscalYear: (state, action) => {
      state.activeFiscalYear = action.payload;
    },
    setNewFiscalYear: (state, action) => {
      let tempFiscalYears = [...state.fiscalyear];
      if (action.payload.is_active && tempFiscalYears.length) {
        tempFiscalYears = tempFiscalYears.map((year) => ({
          ...year,
          is_active: false
        }));
      }
      state.fiscalyear = [action.payload, ...tempFiscalYears];
    },
    patchFiscalYear: (state, action) => {
      let tempFiscalYear = [...state.fiscalyear];
      const index = tempFiscalYear.findIndex((fiscal) => fiscal.id === action.payload.id);
      if (index !== -1) {
        tempFiscalYear = tempFiscalYear.map((year) => ({
          ...year,
          is_active: false
        }));
        tempFiscalYear[index] = action.payload;
      }
      state.fiscalyear = [...tempFiscalYear];
    },
    removeFiscalYear: (state, action) => {
      let tempFiscalYear = [...state.fiscalyear];
      const index = tempFiscalYear.findIndex((fiscal) => fiscal.id === action.payload);
      tempFiscalYear.splice(index, 1);
      state.fiscalyear = [...tempFiscalYear];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

// Actions generated from the slice
const {
  setFiscalYear,
  setNewFiscalYear,
  patchFiscalYear,
  setActiveFiscalYear,
  removeFiscalYear,
  setLoading
} = fiscalSlice.actions;

// export user selector to get the slice in any component
export const fiscalSelector = (state) => state.fiscalyear;

// export The reducer
const fiscalReducer = fiscalSlice.reducer;

export default fiscalReducer;

// Actions
export const fetchFiscalYear = (params) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await fetchWrapper.get('/fiscal-year/' + params);
    dispatch(setFiscalYear({ data: response.data.results, count: response.data.count }));
    dispatch(setLoading(false));
  } catch (error) {
    // dispatch(getUsersFailure());
    dispatch(setLoading(false));
  }
};
export const fetchActiveFiscalYear = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const activeFiscalYear = await fetchWrapper.get('/fiscal-year/active/');
    dispatch(setActiveFiscalYear(activeFiscalYear.data));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setLoading(false));
  }
};

export const createFiscalYear = (data, lang, handleFiscalYearForm) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await fetchWrapper.post('/fiscal-year/', data, '', lang);
    if (data.is_active) {
      dispatch(setActiveFiscalYear(data));
    }
    dispatch(setNewFiscalYear(response.data));
    dispatch(setUiMessage(response.message));
    dispatch(setLoading(false));
    handleFiscalYearForm();
  } catch (error) {
    ErrorMessageHandler(error);

    if (error?.error?.non_field_error) {
      dispatch(setUiError(error.error.non_field_error));
      dispatch(setLoading(false));
    }
  }
};
export const editFiscalYear = (data, lang) => async (dispatch) => {
  try {
    dispatch(setLoading(true));

    const response = await fetchWrapper.patch(`/fiscal-year/${data.id}/`, data, null, lang);
    if (data.is_active) {
      dispatch(setActiveFiscalYear(data));
    }

    dispatch(patchFiscalYear(response.data));
    dispatch(setUiMessage(<FormattedMessage id="fiscal_year_updated" />));
    dispatch(setLoading(false));
  } catch (error) {
    if (error?.error?.non_field_error) {
      dispatch(setUiError(error.error.non_field_error));
      dispatch(setLoading(false));
    }
  }
};

export const deleteFiscalYear = (id) => async (dispatch) => {
  try {
    await fetchWrapper.delete(`/fiscal-year/${id}/`);
    dispatch(removeFiscalYear(id));
    dispatch(setUiMessage(<FormattedMessage id="fiscal_year_deleted" />));
  } catch (error) {
    if (error?.error?.non_field_error) {
      dispatch(setUiError(error.error.non_field_error));
    }
  }
};
